// This module must be imported as the VERY FIRST import in main.js.
//
// Angular's bindJQuery() fires when angular.js evaluates (module-level side
// effect inside publishExternalAPI). It checks window.jQuery at that moment
// and permanently switches to either full jQuery or jqLite — it never retries.
//
// Rollup inlines modules in depth-first import order. By importing this file
// first in main.js, its body (window.jQuery = $) runs before the angular
// import chain is processed, so bindJQuery() always finds full jQuery.
import $ from 'jquery';

// Establish all browser globals that code throughout the app expects.
// DO NOT move these assignments to main.js body — main.js body runs only
// after ALL its imports have been evaluated (including angular).
(window as any).jQuery = $;
(window as any).$ = $;
